import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Award, ShieldCheck, Facebook, Linkedin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-gray-400 border-t border-slate-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12 text-sm leading-relaxed">
        {/* Column 1: Firmainfo */}
        <div className="space-y-4">
          <h3 className="text-white font-extrabold uppercase tracking-widest text-base">
            Firmainfo
          </h3>
          <div className="space-y-3">
            <p className="font-semibold text-gray-200 uppercase tracking-wider text-xs">
              Møldrup VVS A/S
            </p>
            <div className="flex items-start space-x-3">
              <MapPin className="w-5 h-5 text-blue-500 shrink-0 mt-0.5" />
              <p>
                Møllegade 4<br />
                9632 Møldrup<br />
                Danmark
              </p>
            </div>
            <div className="flex items-center space-x-3">
              <Phone className="w-5 h-5 text-blue-500 shrink-0" />
              <a href="tel:+4586692099" className="hover:text-white transition-colors duration-150 whitespace-nowrap">
                86 69 20 99
              </a>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="w-5 h-5 text-blue-500 shrink-0" />
              <a href="mailto:info@moeldrupvvs.dk" className="hover:text-white transition-colors duration-150 whitespace-nowrap">
                info@moeldrupvvs.dk
              </a>
            </div>
            <p className="text-xs text-gray-500 pt-2">
              CVR nr.: <span className="whitespace-nowrap">20966998</span>
            </p>
            <div className="flex items-center space-x-3 pt-4">
              <a
                href="https://www.facebook.com/profile.php?id=61575205066173"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-900 hover:bg-blue-600 text-gray-400 hover:text-white p-2.5 transition-colors duration-150"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/m%C3%B8ldrup-vvs-a-s"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-900 hover:bg-blue-600 text-gray-400 hover:text-white p-2.5 transition-colors duration-150"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Column 2: Vi Tilbyder */}
        <div className="space-y-4">
          <h3 className="text-white font-extrabold uppercase tracking-widest text-base">
            Vi tilbyder
          </h3>
          <ul className="space-y-2 text-xs font-semibold uppercase tracking-wider">
            <li>
              <Link to="/ydelser" className="hover:text-white transition-colors duration-150">
                Varmepumper & Jordvarme
              </Link>
            </li>
            <li>
              <Link to="/ydelser" className="hover:text-white transition-colors duration-150">
                Moderne Badeværelser
              </Link>
            </li>
            <li>
              <Link to="/ydelser" className="hover:text-white transition-colors duration-150">
                Blikkenslagerarbejde
              </Link>
            </li>
            <li>
              <Link to="/ydelser" className="hover:text-white transition-colors duration-150">
                Ventilation & Genvex
              </Link>
            </li>
            <li>
              <Link to="/ydelser" className="hover:text-white transition-colors duration-150">
                Renovering & Nybyggeri
              </Link>
            </li>
            <li>
              <Link to="/ydelser/haandvaerkergaranti" className="hover:text-white transition-colors duration-150 text-blue-500">
                Håndværkergaranti
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3: Garantisertifikater */}
        <div className="space-y-4">
          <h3 className="text-white font-extrabold uppercase tracking-widest text-base">
            Garanti & Sikkerhed
          </h3>
          <p className="text-xs text-gray-400">
            Vi er medlem af godkendte garantiordninger, hvilket sikrer dig veludført og forsvarligt arbejde af højeste kvalitet.
          </p>
          <div className="flex flex-wrap gap-4 pt-2">
            {/* Håndværkergaranti Logo */}
            <Link to="/ydelser/haandvaerkergaranti" className="block bg-white p-2 hover:opacity-90 transition-opacity duration-150">
              <img
                src="https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/a81b6ce7-e3ad-412c-bcb0-79943202b635.png"
                alt="Håndværkergaranti"
                className="h-12 w-auto object-contain"
              />
            </Link>
            {/* Q-kontrol Logo */}
            <Link to="/ydelser/haandvaerkergaranti" className="block bg-white p-2 hover:opacity-90 transition-opacity duration-150">
              <img
                src="https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/a0fd4a77-e16a-4e8d-a760-f32e74b378f4.jpg"
                alt="Q-kontrol"
                className="h-12 w-auto object-contain"
              />
            </Link>
            {/* AAA Kreditværdighed Logo */}
            <div className="block">
              <img
                src="http://www.xn--mldrupvvs-l8a.dk/wp-content/uploads/2020/06/AAA_resize5.png"
                alt="AAA Kreditværdighed"
                className="h-16 w-auto object-contain"
              />
            </div>
            {/* Anmeld Håndværker Logo */}
            <div className="smiley-wrapper">
              <a 
                href="//www.anmeld-haandvaerker.dk/vvs/moldrup-vvs?utm_source=smileybox&amp;utm_medium=referral&amp;utm_campaign=moeldrup-vvs&amp;utm_term=smileyboxv1" 
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-white p-2 hover:opacity-90 transition-opacity duration-150"
              >
                <div className="smiley2 greensmiley flex items-center bg-white text-[#008248] px-2 py-1" style={{ minWidth: '160px', height: '48px' }}>
                  <div className="left mr-2 flex items-center justify-center">
                    <img
                      src="https://assets.auxodev.dk/assets/2750d3ac-cba1-4299-92fa-1fa2c5bb200b/b257d022-9900-4c9e-ade2-e1879466928f.png"
                      alt="Smiley"
                      className="w-7 h-7 object-contain"
                    />
                  </div>
                  <div className="right flex flex-col justify-center leading-tight">
                    <div className="head2 font-extrabold text-[10px] tracking-wider" style={{ paddingTop: '1px' }}>ANMELD</div>
                    <div className="head2 font-extrabold text-[10px] tracking-wider">HÅNDVÆRKER</div>
                    <div className="head3 text-[8px] text-gray-500">Senest anmeldt: 21.11.08</div>
                    <div className="head3 text-[8px] text-gray-500">1 anmeldelser</div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-slate-900/60 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600 space-y-4 md:space-y-0">
        <p>
          &copy; {currentYear} Møldrup VVS A/S. Alle rettigheder forbeholdes.
        </p>
        <p className="tracking-widest uppercase text-[10px]">
          Kvalitetsbevidst og troværdig – med et højt serviceniveau
        </p>
      </div>
    </footer>
  );
}
